module.exports = __webpack_public_path__ + "img/step3.9c1b2d6e.png";